// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions'; // Add this import
import ScrollToTopOnNavigate from './components/UI/ScrollToTopOnNavigate';
import ChatBot from './components/ChatBot/ChatBot';

function App() {
  return (
    <Router>
      <div className="App">
        <GlobalStyles />
        <ScrollToTopOnNavigate />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsAndConditions />} />
          </Routes>
        </main>
        <Footer />

        {/* Show chatbot only on Home, About and Services Pages */}
        <Routes>
          <Route path="/" element={<ChatBot />} />
          <Route path="/about" element={<ChatBot />} />
          <Route path="/services" element={<ChatBot />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;